<template>
  <div class="gameplan">
      <!-- 新建活动 -->
      <div class="activity_new">
        <div class="normal_title">
          <span style="cursor: pointer;" @click="showDetail=!showDetail"> <i :class="showDetail?'el-icon-caret-bottom':'el-icon-caret-right'">&ensp;</i>{{ getDetailName }}</span>
        </div>
        <div class="pr-box" v-if="showDetail">
          <div class="assign-region-box" v-if="inputData.length>0">
            <span class="needTransitions-style">{{ themeDetail.needTransitions?'转场':'非转场' }}</span>
            <span class="needTransitions-perExecDays">{{ themeDetail.needTransitions?'' :`每${getUnits()}执行活动天数：${themeDetail.perExecDays}` }}</span>
            <el-form>
              <el-form-item class="input-width-sp" label="额度分配" prop="itemQuantity" ref="itemQuantityRef">
                <el-select v-model="assignList" @change="handleChangeAssignList" multiple collapse-tags clearable placeholder="请选择">
                  <div v-if="assignCodeList.length>0">
                    <el-option 
                      v-for="item in assignCodeList" 
                      :key="item.orgCode" 
                      :label="getName(item.orgName)" 
                      :value="item.orgCode">
                    </el-option>
                  </div>
                </el-select>&ensp;&ensp;
                  {{ !themeDetail.needTransitions?'总'+getUnits()+ getTotalCountQty:'' }} &ensp;&ensp;
                  {{'总活动执行天数'}}：{{  (!themeDetail.needTransitions?Number(themeDetail.perExecDays)*Number(getTotalCountQty): getTotalCountQty) |toThousandslsFilter()}}&ensp;&ensp; 
                  已分配：{{getAllAssignQty |toThousandslsFilter()}} &ensp;&ensp;
                  <span v-if="!isOwner">未分配：{{(getTotalCountQty - getAllAssignQty) |toThousandslsFilter()}}</span>&ensp;&ensp;
                  <span v-if="isBU">执行人：{{ userInfo.clientName }}</span>
                <!-- <span>总场次：{{getAllAssignQty}}场</span> -->
              </el-form-item>
              <div class="config-detail-bu">
                <div class="assign-box" >
                  <el-form v-for="(item,index) of assignInfoList" label-position="left" :model="item" :key="item.orgName" ref="assignFormRef" :rules="editRules" hide-required-asterisk @submit.native.prevent>
                    <el-form-item class="assign-item" :label="getName(item.orgName)" v-if="assignList.indexOf(item.orgCode)!==-1">
                      <template slot="label">
                        <div class="assign-title-box">
                          <div style="font-weight:600">
                            <!-- <span class="required-text">*</span> -->
                            {{getName(item.orgName)}}
                          </div>
                          <div v-if="isHQ" class="assign-title-delete"><i @click="handleDeleteAssign(item)" class="el-icon-delete"></i></div>
                        </div>
                      </template>
                      <div class="assign-detail">
                        <el-input type="number" oninput="value=value.replace(/[^\d]/g,'')" :min="getNextAssignQty(item.regionAssignList,item.submitCountQty)" class="item" v-model="item.assignQty" placeholder="请输入分配额度"
                        @blur="(...val) => updateSubmitData(getNextAssignQty(item.regionAssignList)||item.submitCountQty,index,item.assignQty,...val)" />
                        <el-select class="assign-executor" v-if="assignList.indexOf(item.orgCode)!==-1&&isHQ" v-model="item.executorCodeList" @change="handleSelectExecutor(item)" multiple collapse-tags clearable placeholder="请选择">
                          <div v-if="item.m3List.length>0">
                            <el-option 
                              v-for="person in item.m3List" 
                              :key="person.employeeCode" 
                              :label="getName(person.clientName)" 
                              :value="person.employeeCode">
                            </el-option>
                          </div>
                        </el-select>
                      </div>
                      <div class="assign-num-box">
                        <div> 原额度：{{  item.saveAssignQty |toThousandslsFilter() }} <span style="display:inline-block;margin-left:10px" :class="getDifferenceValue(item.assignQty,item.saveAssignQty)>0?'color-green':'color-red'" v-if="item.saveAssignQty&&getDifferenceValue(item.assignQty,item.saveAssignQty)!==0">{{ (getDifferenceValue(item.assignQty,item.saveAssignQty)>0?'+':'') + getDifferenceValue(item.assignQty,item.saveAssignQty)}}</span></div>
                        <div v-if="isHQ"> 已下发：{{ getNextAssignQty(item.regionAssignList) |toThousandslsFilter()}}</div>
                        <div v-if="(isBU||isRegion)"> 已提报：{{ item.submitCountQty |toThousandslsFilter() }}</div>
                      </div>
                        <!-- <div> {{ getAssignQty(item.assignQty) }} </div> -->
                    </el-form-item>
                  </el-form> 
                </div>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import gameplanApi from "@/api/gameplan";
import { commonUtils } from '@/utils/common'
import { mapGetters } from 'vuex'
export default {
  name: 'ActivityChangeAssign',
  data() {
    return {
      themeId:'',
      themeChannelCode:'',
      themeBasic:{},
      loading:false,
      showDetail:true,
      themeDetail:{},
      inputData:[],
      assignInfoList:[],
      assignList:[],
      total:0,
      count:0,
      remain:0,
      editRules: {
        assignQty:[{required: true, message: '请输入额度配置', trigger: 'blur' }],
      },
      subAssignList:[],
      curAssignList:[]
    };
  },
  created(){
    this.employeeLevel = this.userInfo.employeeLevel
    this.themeDetail = this.itemInfo.themeDetail || {}
    if(this.isRegion) this.subAssignList = this.itemInfo.curAssignList || []
    else this.subAssignList = this.itemInfo.subAssignList || []
    this.curAssignList = this.itemInfo.curAssignList || []
    this.init()
  },
  props: {
    itemInfo:{ type: Object, default: () => {} },
    assignCodeList:{ type: Array, default: () => [] },
    typeKey:{ type: String, default: '' },
    itemIndex:{type:Number,default:0},
    isOwner:{type:Boolean,default:false}
  },
  watch:{
    assignCodeList:{
      handler:function(){
        this.init()
      }
    }
  },
  computed:{
    ...mapGetters(['userInfo']),
    isHQ(){
      return this.employeeLevel>=90
    },
    isBU(){
      return this.employeeLevel>=60&&this.employeeLevel<90
    },
    isRegion(){
      return this.employeeLevel>=45&&this.employeeLevel<60
    },
    getBrandInfo(){
      const gpPrDTO = this.themeBasic.gpPrDTO
      if(gpPrDTO){
        if(gpPrDTO.brandName&&gpPrDTO.subBrandName){
          return gpPrDTO.brandName+'-'+gpPrDTO.subBrandName
        }else return gpPrDTO.brandName||gpPrDTO.subBrandName
      }else return '暂无'
    },
    getOrgLevel(){
      if(this.themeBasic.orgLevel&&this.themeBasic.orgLevel.length===2) return this.themeBasic.orgLevel.toUpperCase()
      else return 'Region'
    },
    getTotalCountQty(){
      let assignQty 
      if(this.curAssignList&&this.curAssignList.length>0){
        assignQty = this.curAssignList.reduce((pre,cur)=>{
          return  pre+Number(cur.assignQty)
        },0)
      }else {
        assignQty = this.subAssignList.reduce((pre,item)=>{
          return pre + Number(item.assignQty)
        },0)
      }
      // return this.params.needTransitions?assignQty:assignQty*this.params.perExecDays
      return assignQty
    },
    getAllAssignQty(){
       let assignQty = this.assignInfoList.reduce((pre,item)=>{
        return pre + Number(item.assignQty)
      },0)
      // return this.params.needTransitions?assignQty:assignQty*this.params.perExecDays
      return assignQty || 0
    },
    getDetailName(){
      return this.themeDetail.themeStyleName + (this.themeDetail.themeLevelName?'-'+this.themeDetail.themeLevelName :'')
    }
  },
  methods: {
    init(){
      this.inputData = []
      let count = 0
      this.assignInfoList =  this.assignCodeList.map(assignItem=>{
        let data = {
          orgName:assignItem.orgName,
          orgCode:assignItem.orgCode,
          assignQty:assignItem.assignQty||0,
          // regionAssignList:[],
          assignId:(this.subAssignList[0]&&this.subAssignList[0].assignId) || '',
          m3List:assignItem.m3List || [],
          executorList:[],
          executorCodeList:[]
        }
        return data
      })
      if(this.isBU){
        this.subAssignList.forEach(item=>{
          let data = {
            assignQty:item.assignQty,
            regionCode:item.regionCode
          }
          count+=item.assignQty
          this.inputData.push(data)
        })
      }else if(this.isHQ){
        this.subAssignList.forEach(item=>{
          let data = {
            assignQty:item.assignQty,
            buCode:item.buCode,
            assignStatus:item.assignStatus,
          }
          count+=item.assignQty
          this.inputData.push(data)
        })
      }else if(this.isRegion){
        this.subAssignList.forEach(item=>{
          let data = {
            assignQty:item.assignQty,
            regionCode:item.regionCode,
            assignStatus:item.assignStatus,
          }
          count+=item.assignQty
          this.inputData.push(data)
        })
      }
      this.assignList = this.subAssignList.map(item=>{
        return item[this.typeKey]
      })
      this.subAssignList.forEach(savedItem=>{
        this.assignInfoList.forEach(assignItem=>{
          if(savedItem[this.typeKey]===assignItem.orgCode){
            //console.log(savedItem.submitCountQty);
            assignItem.assignQty = savedItem.assignQty
            assignItem.saveAssignQty = savedItem.assignQty
            assignItem.regionAssignList = savedItem.regionAssignList
            assignItem.submitCountQty = savedItem.submitCountQty
            //assignItem.assignId = savedItem.assignId
          }
        })
      })
      if(this.itemInfo.executorList){
        this.assignInfoList.forEach(assignItem=>{
          this.itemInfo.executorList.forEach(savedItem=>{
            if(savedItem.buCode===assignItem.orgCode){
              assignItem.executorCodeList.push(savedItem.executorCode)
              assignItem.executorList.push(savedItem)
            }
          })
        })
      }
      this.total = this.subAssignList.assignQty || count
      this.count = count
      this.remain = this.subAssignList.assignQty - count || 0
    },
    async getGameplanThemeNewDetailList() {
      const params = {
        themeChannelCode:this.themeChannelCode,
        themeId:this.themeId
      }
      console.log(params);
      const res = await gameplanApi.getGameplanThemeNewDetailList(params);
      if (res.data.resultCode === "0") {
        this.themeBasic= res.data.resultData.detailList[0].themeDetail || []
      }
      this.loading = false
    },
    handleDeleteAssign(item){
      this.assignList = this.assignList.filter(selectedItem=>{
        return selectedItem!==item.orgCode
      })
      this.handleChangeAssignList()
    },
    handleSelectExecutor(buItem){
      buItem.executorList = []
      buItem.m3List.forEach(item=>{
        if(buItem.executorCodeList.indexOf(item.employeeCode)!==-1){
          const data = {
            buCode:buItem.orgCode,
            executorCode:item.employeeCode,
            themeId:this.themeDetail.themeId,
            themeDetailId:this.themeDetail.themeDetailId
          }
          buItem.executorList.push(data)
        }
      })
    },
    updateSubmitData(min,index,assignQty){
      if(Number(min)>Number(assignQty)&&assignQty!==''){
        this.assignInfoList[index].assignQty= min || 0
        this.$message.error(`额度分配不可小于${this.isHQ?'已下发':'已提报'}`)
      }
    },
    handleChangeAssignList(val){
      this.assignInfoList.forEach(assignItem=>{
        const isSelected = this.assignList.indexOf(assignItem.orgCode)!==-1
        if(!isSelected){
          assignItem.assignQty=''
        }
      })
    },
    getDifferenceValue(first,second){
      return Number(first) - Number(second)
    },
    getName(str){
      if(str){
          return str.split('|')[0] || str
      }else return ''
    },
    getNextAssignQty(list,submitCountQty){
      if(this.isBU){
        return submitCountQty || 0
      }else if(this.isHQ&&list){
        let assignQty = list.reduce((pre,item)=>{
          return pre + Number(item.assignQty)
        },0)
        return assignQty || 0
      }
      // return this.params.needTransitions?assignQty:assignQty*this.params.perExecDays
      return 0
    },
    getUnits(){
      let key = this.themeDetail.pocRelateType+''
      let units = '街区'
      switch (key) {
        case '0':
          units = '活动地点'
          break;
          case '1':
          units = '售点'
          break;
        default:
        units = '街区'
          break;
      }
      return units
    },
    openFile(type){
      if(type === 'execTemplateUri'){
        window.open(commonUtils.getImageUrl(this.themeBasic.execTemplateUri))
      }else if(type === 'manualFileUri'){
        window.open(commonUtils.getImageUrl(this.themeBasic.manualFileUri))
      }
    },
    submit(){
      let isRequired = false
      let requiredItem = {}
      let subAssignList = this.assignInfoList.filter(assignItem=>{
          //console.log(this.assignList.indexOf(assignItem.orgCode)!==-1);
          const isSelected = this.assignList.indexOf(assignItem.orgCode)!==-1
          if(!isSelected&&(((this.isBU||this.isRegion)&&assignItem.submitCountQty&&assignItem.submitCountQty!==0)||(this.isHQ&&assignItem.regionAssignList&&this.getNextAssignQty(assignItem.regionAssignList)!==0))){
            requiredItem=assignItem 
            isRequired = true
          } 
        return isSelected
      })
      if(isRequired) return this.$message.error(`"${this.getDetailName}-${this.getName(requiredItem.orgName)}"${this.isHQ?'已下发':'已提报'}，请选中"${this.getName(requiredItem.orgName)}"并分配额度`)
      let valid = true
      let errorMessage = ''
      subAssignList.forEach(item=>{
        if(item.assignQty===''){
          valid = false
          !errorMessage?errorMessage=`"${this.getDetailName+'-'+this.getName(item.orgName)}"未分配额度，请重新填写`:''
        }else if(this.isHQ&&item.executorList.length===0){
          valid = false
          !errorMessage?errorMessage=`"${this.getDetailName+'-'+this.getName(item.orgName)}"未选择执行人，请重新选择`:''
        }
      })
      if(!valid){
        return this.$message.error(errorMessage)
      }
      if((this.getTotalCountQty - this.getAllAssignQty)<0&&!this.isOwner) return this.$message.error('额度超出可分配数量！')
      this.handleThemeRelocation(subAssignList)
    },
    async handleThemeRelocation(subAssignList){
      let themeDetail = {
        themeDetailId:this.themeDetail.themeDetailId,
        themeId:this.themeDetail.themeId
      }
      // let subAssignList = this.assignInfoList.filter(assignItem=>{
      //     //console.log(this.assignList.indexOf(assignItem.orgCode)!==-1);
      //   return this.assignList.indexOf(assignItem.orgCode)!==-1
      // })
      subAssignList = subAssignList.map(assignItem=>{
        this.typeKey?assignItem[this.typeKey] = assignItem.orgCode:''
        return assignItem
      })
      const executorList = subAssignList.reduce((pre,cur)=>{
        // return cur.executorList?pre.concat(cur.executorList):pre
        return pre.concat(cur.executorList)
      },[])
      let params = {
        subAssignList,
        executorList,
        themeDetail,
        curAssignList:this.curAssignList
      }
      console.log(subAssignList);
      this.$emit('handleSubAssignList',params,this.itemIndex,true)
    },
  },
};
</script>

<style lang="scss" scoped>
.content-wrapper {

.activity_new {
  position: relative;
 // margin-top: -50px;

  .activity-new-card {
    padding: 20px 10px 20px 0px;
    background-color: #ffffff;
    color: #101010;
    border-radius: 10px;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    font-family: SourceHanSansSC-bold;
    display: flex;
    justify-content: flex-start;

    .po_config_btn {
      cursor: pointer;
      position: absolute;
      right: 0;
      top: -25px;
      width: 120px;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      background-color: #539efe;
      color: #ffffff;
      font-size: 14px;
      text-align: center;
      font-family: Roboto;
    }
  }

  .activity_channel_checkbox {
    margin: -5px 0 20px 40px;
  }

  .activity_channel_checkbox_label {
    text-align: center;
    position: relative;
    top: 15px;
    line-height: 18px;
  }
}
}
.pr-box{
  width: calc(100% - 50px);
  padding: 15px 25px 15px 25px;
  background-color: #ffffff;
  border-radius: 8px;
  .pr-item{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 12px;
  }
  .space-between{
    justify-content: space-between;
  }
  .pr-title{
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
  }
  .pr-level{
    color: white;
    display: inline-block;
    font-size: 14px;
    line-height: 18px;
    padding: 0 10px;
    background-color: rgb(71, 172, 255);
  }
  .pr-status {
    color: rgb(192, 1, 1);
    font-size: 16px;
    font-weight: 600;
  }
}
::v-deep .input-width-sp .el-input__inner {
  width: 200px;
}
::v-deep .assign-box .el-input__inner {
  width: 155px !important;
  padding-right: 25px;
}
::v-deep .assign-box .el-form-item {
  display: flex;
  flex-direction: column;
  margin-right: 20px;
}
.assign-box{
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
}
.needTransitions-style{
  color: rgb(230, 0, 0);
  font-weight: 600;
  display: inline-block;
  margin: 10px 0 15px 0;
}
.needTransitions-perExecDays{
  font-weight: 600;
  display: inline-block;
  margin: 10px 0 15px 50px;
}
// .config-detail-bu{
//   margin-left:180px;
// }
.el-form-item{
  width: 97%;
}
.assign-detail{
  display:flex;
}
::v-deep .assign-executor .el-input__inner{
  width:180px !important;
}
::v-deep .config-detail-bu .required-text{
  margin-left:0;
}
::v-deep .config-detail-bu .el-form-item{
  margin-bottom:0px !important;
}
::v-deep .el-form-item__content{
   margin-right:20px;
}
.assign-title-box{
  width:100%;
  display:flex;
  justify-content:space-between;
  align-items:center;
}
.assign-title-delete{
  margin-right:10px;
  cursor:pointer;
  font-size:20px;
  color:rgb(226, 0, 0);
}
.assign-num-box {
  margin-top:10px;
  div{
    line-height:25px;
  }
}
.color-red{
  color:rgb(226, 0, 0);
}
.color-green{
  color:rgba(0, 223, 30, 0.733);
}
</style>